import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@medprompt/shared';

const OAuthCallbackController = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { nhsLogin, nhsOnboard } = useAuth(); // Get setter functions

  
  useEffect(() => {
    const handleOAuthCallback = async () => {
      try {
        // Extract URL parameters
        const code = searchParams.get('code');
        const state = searchParams.get('state');

        console.log('OAuth Callback received:', { code, state });

        // Validate state parameter
        const storedState = sessionStorage.getItem('oauth_state');
        if (!state || state !== storedState) {
          sessionStorage.removeItem('oauth_state');
          throw new Error('Invalid state parameter - possible CSRF attack');
        }

        // Clear the stored state
        sessionStorage.removeItem('oauth_state');

        await processOAuthCallback(code);
      } catch (err) {
        console.error('OAuth callback error:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    handleOAuthCallback();
  }, [searchParams]);

  
  // TODO: Implement your OAuth callback logic here
  const processOAuthCallback = async (code) => {
    if (!code) {
      throw new Error('Authorization code not found');
    }

    // Determine whether this flow was a login or an onboarding
    const action = sessionStorage.getItem('oauth_action');
    sessionStorage.removeItem('oauth_action');

    if (action === 'onboard') {
      const email = sessionStorage.getItem('oauth_email');
      sessionStorage.removeItem('oauth_email');
      if (!email) {
        throw new Error('Email not found in session storage for onboarding');
      }
      await nhsOnboard(email, code);

      // After successful onboarding, navigate to home and open user tab
      console.log('NHS onboarding successful; redirecting to home user tab');
      navigate('/', { replace: true, state: { selectTab: 'user' } });
      return;
    }

    // Default behaviour – treat as full login
    await nhsLogin(code);

    // Improved navigation logic to handle different state formats
    let targetPath = '/';
    if (location.state?.from) {
      if (typeof location.state.from === 'string') {
        targetPath = location.state.from;
      } else if (location.state.from.pathname) {
        targetPath = location.state.from.pathname;
      }
    }
    
    console.log('NHS login successful, navigating to:', targetPath);
    navigate(targetPath, { replace: true });
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div>Processing OAuth callback...</div>
        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
          Please wait while we complete the authentication process.
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div style={{ color: 'red', marginBottom: '10px' }}>
          OAuth Error: {error}
        </div>
        <button onClick={() => navigate('/login')}>
          Return to Login
        </button>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div>Authentication successful!</div>
      <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
        Redirecting you to the application...
      </div>
    </div>
  );
};

export default OAuthCallbackController; 